/**
 * Переключатель дизайна: 'classic' (по умолчанию) | 'cp' (CP-редизайн).
 *
 * Значение определяется один раз при загрузке страницы (сначала выбор пользователя в localStorage,
 * затем window.config.design, иначе 'classic'), поэтому смена дизайна выполняется с перезагрузкой страницы.
 * Модуль намеренно не зависит от остального приложения — его импортируют обёртки файлов `*.js` (`*.classic.js` / `*.cp.js`).
 */
export const DESIGN_CLASSIC = 'classic';
export const DESIGN_CP = 'cp';

const STORAGE_KEY = 'design';

const normalize = (value) => (value === DESIGN_CP ? DESIGN_CP : value === DESIGN_CLASSIC ? DESIGN_CLASSIC : null);

const readStored = () => {
  try {
    return normalize(window.localStorage.getItem(STORAGE_KEY));
  } catch (e) {
    return null;
  }
};

const readConfig = () => normalize(window.config && window.config.design);

export const design = readStored() || readConfig() || DESIGN_CLASSIC;
export const isCp = design === DESIGN_CP;

/**
 * Сохранить выбор пользователя и перезагрузить страницу
 */
export const setDesign = (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, normalize(value) || DESIGN_CLASSIC);
  } catch (e) {
    /* storage disabled — ignore */
  }
  window.location.reload();
};

/**
 * Подключить ресурсы выбранного дизайна: шрифты (@fontsource, грузятся отдельными чанками только нужного дизайна)
 */
export const applyDesignAssets = () => {
  document.documentElement.setAttribute('data-design', design);
  if (isCp) {
    import('@fontsource/ibm-plex-sans/400.css');
    import('@fontsource/ibm-plex-sans/500.css');
    import('@fontsource/ibm-plex-sans/600.css');
    import('@fontsource/ibm-plex-sans/700.css');
  } else {
    import('@fontsource/roboto/400.css');
  }
};
